import {ModalAlertContent, ModalDefaultTitle, ModalTimeOfBirth} from "src/styles/common/modal";
import CheckBoxForm from "src/component/common/CommonForm/CheckBoxForm";
import {useRecoilState} from "recoil";
import {TimeOfBirthState} from "src/store/UserPage/fortune";


export const TimeOfBirthItems = [
    {idx: 0, text: "모름"},
    {idx: 1, text: "子(자) 23:30 ~ 01:29"},
    {idx: 2, text: "丑(축) 01:30 ~ 03:29"},
    {idx: 3, text: "寅(인) 03:30 ~ 05:29"},
    {idx: 4, text: "卯(묘) 05:30 ~ 07:29"},
    {idx: 5, text: "辰(진) 07:30 ~ 09:29"},
    {idx: 6, text: "巳(사) 09:30 ~ 11:29"},
    {idx: 7, text: "午(오) 11:30 ~ 13:29"},
    {idx: 8, text: "未(미) 13:30 ~ 15:29"},
    {idx: 9, text: "申(신) 15:30 ~ 17:29"},
    {idx: 10, text: "酉(유) 17:30 ~ 19:29"},
    {idx: 11, text: "戌(술) 19:30 ~ 21:29"},
    {idx: 12, text: "亥(해) 21:30 ~ 23:29"},

]

const TimeOfBirth = (props: any) => {
    const {ClickFunc} = props
    const [TimeOfBirthValue, setTimeOfBirthValue] = useRecoilState(TimeOfBirthState)
    return (
        <ModalAlertContent>
            <ModalDefaultTitle className={"time_of_birth"}>출생시간</ModalDefaultTitle>
            <ModalTimeOfBirth>
                <CheckBoxForm
                    data={TimeOfBirthItems}
                    checked={TimeOfBirthValue}
                    onChange={setTimeOfBirthValue}
                    onSuccess={ClickFunc}/>
            </ModalTimeOfBirth>
        </ModalAlertContent>
    )
}
export default TimeOfBirth